import * as React from "react";
import { scaleLinear } from "d3-scale";
import { extent } from "d3-array";
import Dots from "./Scatterplot-Dots";
import Labels from "./Scatterplot-Labels";
import { IResult } from "./IOPair";
import styled from "./styled-components";
interface IProps {
  width: number;
  height: number;
  data: IResult[];
}

const Container = styled.div`
  font-size: 11px;
  display: inline-block;
`;

class Scatterplot extends React.Component<IProps, any> {
  public render() {
    const { width, height, data } = this.props;
    if (data.length > 0) {
      const x = scaleLinear()
        .domain(extent(data, (d: IResult) => d.x) as number[])
        .range([60, width - 30])
        .nice();
      const y = scaleLinear()
        .domain(extent(data, (d: IResult) => d.y) as number[])
        .range([height - 30, 30])
        .nice();
      const transitionDuration = 1000;
      return (
        <Container>
          <svg width={width} height={height}>
            <Dots
              xScale={x}
              yScale={y}
              transitionDuration={transitionDuration}
              data={data}
            />
            <Labels
              xScale={x}
              yScale={y}
              transitionDuration={transitionDuration}
              data={data}
            />
          </svg>
        </Container>
      );
    }
    return <p>no data</p>;
  }
}

export default Scatterplot;



// WEBPACK FOOTER //
// ./src/Scatterplot.tsx